module.exports = __webpack_public_path__ + "img/markerAqua.dda2f2e1.svg";